import { render, staticRenderFns } from "./PasteModal.vue?vue&type=template&id=4a36f471&lang=pug&"
import script from "./PasteModal.vue?vue&type=script&lang=js&"
export * from "./PasteModal.vue?vue&type=script&lang=js&"
import style0 from "./PasteModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports